'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _catalog = require('./mock/catalog');

var _catalog2 = require('./remote/catalog');

var Catalog = {
    fetchCatalogItems: function fetchCatalogItems(params) {
        return __MOCK__ ? _catalog.CatalogMock.fetchCatalogItems(params) : _catalog2.CatalogRemote.fetchCatalogItems(params);
    },
    fetchCatalogsByIds: function fetchCatalogsByIds(params) {
        return __MOCK__ ? _catalog.CatalogMock.fetchCatalogsByIds(params) : _catalog2.CatalogRemote.fetchCatalogsByIds(params);
    },
    fetchCuratorsForCatalog: function fetchCuratorsForCatalog(params) {
        return _catalog2.CatalogRemote.fetchCuratorsForCatalog(params);
    },
    fetchRegisteredCatalogs: function fetchRegisteredCatalogs(params) {
        return _catalog2.CatalogRemote.fetchRegisteredCatalogs(params);
    },
    postCatalogItems: function postCatalogItems(params) {
        return _catalog2.CatalogRemote.postCatalogItems(params);
    },
    postRegisterForCatalog: function postRegisterForCatalog(params) {
        return _catalog2.CatalogRemote.postRegisterForCatalog(params);
    }
};

exports.default = Catalog;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/catalog.js
// module id = bRXb
// module chunks = 46